import { render, staticRenderFns } from "./swAbout.vue?vue&type=template&id=8a56645e&scoped=true&"
import script from "./swAbout.vue?vue&type=script&lang=js&"
export * from "./swAbout.vue?vue&type=script&lang=js&"
import style0 from "./swAbout.vue?vue&type=style&index=0&id=8a56645e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a56645e",
  null
  
)

export default component.exports